import React, { useState } from 'react'
import { Panel, Message, Row, Col } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import ManageProjectStatusForm from './ManageProjectStatusForm'
import ManageProjectStatusTable from './ManageProjectStatusTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  getManagementProjectStatus,
  getManagementProjectStatusPage,
  updateManagementProjectStatus,
} from '../../redux/actions/adminProjectManagemant'
import ProjectInfoView from '../projectBasicInfo/ProjectInfoView'
import PopupModal from '../../components/modal/PopupModal'

export default function ManageProjectStatusWidget(props) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props?.schema)
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [expandedSearch, setExpandedSearch] = useState(true)
  const [isChangeSuccess, setIsChangeSuccess] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [projectInfo, setProjectInfo] = useState()
  const [request, setRequest] = useState()
  const onSelect = async (data) => {
    console.log('data => ', data)
    // setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManagementProjectStatus(data.id)

      setExpandedSearch(false)
      setProjectInfo(_schema)
    } catch (e) {
      console.log('error', e)
      setIsError(
        e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    doneLoading()
    // setIsLoading(false)
  }

  const handleSave = async (request) => {
    startLoading()
    setIsError('')
    setIsChangeSuccess(false)
    try {
      const response = await updateManagementProjectStatus(
        projectInfo.projectInfo.projectId,
        request
      )

      setIsChangeSuccess(true)
      // if (response) {
      //   const _schema = await getManagementProjectStatusPage()
      //   setFormSchema(_schema)
      // }

      setProjectInfo()
      setExpandedSearch(true)
    } catch (e) {
      console.log('error', e)
      setIsError(
        e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('data => ', data)
    setRequest({
      note: data.note,
      statusCode: data.projectStatus,
    })
    setIsSubmit(true)
  }

  const onConfirm = () => {
    setIsSubmit(false)
    handleSave(request)
  }
  const onNotConfirm = () => {
    setIsSubmit(false)
    setRequest()
  }

  return (
    <>
      {/* <Panel shaded header={formSchema.header} collapsible defaultExpanded> */}
      <ManageProjectStatusTable
        schema={formSchema.searchForm}
        onSelect={onSelect}
        expanded={expandedSearch}
        isReload={isChangeSuccess}
      />
      {/* </Panel> */}

      {projectInfo && (
        <>
          {/* <hr /> */}
          <Panel
            header={projectInfo.header}
            shaded
            bordered
            collapsible
            defaultExpanded
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            {projectInfo.projectInfo && <ProjectInfoView schema={projectInfo.projectInfo} />}

            <ManageProjectStatusForm
              schema={projectInfo}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
            {isError && (
              <Message
                showIcon
                type="error"
                description={isError}
                closable
                onClose={() => {
                  setIsError('')
                }}
              />
            )}

            <Row style={{ marginTop: 20 }}>
              <Col xs={24} sm={24} md={6} lg={3}>
                <SaveButton block onClick={handleSubmit(onSubmit)}>
                  {`บันทึก`}
                </SaveButton>
              </Col>
              <Col xs={24} sm={24} md={6} lg={3}>
                <CancelButton
                  block
                  onClick={() => {
                    setProjectInfo()
                    setExpandedSearch(true)
                  }}
                >
                  {'ยกเลิก'}
                </CancelButton>
              </Col>
            </Row>
          </Panel>

          <PopupModal
            title={'ยืนยันการบันทึก'}
            isShow={isSubmit}
            body={isSubmit && `ยืนยันการเปลี่ยนสถานะโครงการ`}
            onClickSubmit={onConfirm}
            onClickCancel={onNotConfirm}
            submitText="ยืนยัน"
            cancelText="ยกเลิก"
          />
        </>
      )}
    </>
  )
}
